/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export const MESSAGE_CLIENT_RENDER_ERROR = 'Backend state not found on `window.___initialData___`. Unable to initialize client code.';
